const STEPS = [
  {
    step: '01',
    icon: 'ri-chat-1-line',
    title: 'Оставляете заявку',
    desc: 'Звоните или заполняете форму — обсуждаем задачу и&nbsp;предварительные пожелания.',
  },
  {
    step: '02',
    icon: 'ri-map-pin-line',
    title: 'Выезжаем на замер',
    desc: 'Приезжаем на&nbsp;участок, делаем точные замеры, оцениваем грунт и&nbsp;условия монтажа.',
  },
  {
    step: '03',
    icon: 'ri-draft-line',
    title: 'Готовим расчёт и эскиз',
    desc: 'Проектируем конструкцию, подбираем материалы и&nbsp;составляем подробную смету.',
  },
  {
    step: '04',
    icon: 'ri-settings-3-line',
    title: 'Изготавливаем конструкцию',
    desc: 'Производим все элементы в&nbsp;цеху: сварка, обработка, покраска и&nbsp;контроль качества.',
  },
  {
    step: '05',
    icon: 'ri-truck-line',
    title: 'Доставляем и монтируем',
    desc: 'Привозим готовую конструкцию, собираем на&nbsp;объекте и&nbsp;сдаём вам под ключ.',
  },
];

export default function HowWeWork() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Как мы работаем
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Пять простых шагов от&nbsp;заявки до&nbsp;готового изделия на&nbsp;вашем участке
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-16 left-[10%] right-[10%] h-[2px] bg-background-300"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4">
            {STEPS.map((step) => (
              <div key={step.step} className="relative text-center group">
                {/* Step number circle */}
                <div className="relative z-10 mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 border-2 border-background-200 text-foreground-950 group-hover:bg-primary-500 group-hover:border-primary-500 group-hover:text-background-50 transition-all duration-400 mb-5">
                  <span className="font-heading text-lg font-bold">{step.step}</span>
                </div>

                {/* Icon */}
                <div className="w-10 h-10 mx-auto flex items-center justify-center text-primary-500 mb-3">
                  <i className={`${step.icon} text-2xl`}></i>
                </div>

                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: step.desc }}></p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}